import React, {useEffect, useRef, useState} from 'react';
import * as R from 'ramda';
import { useHistory, useLocation } from 'react-router-dom';
import {UpdatePassword } from '../../../../actions/auth/partnersInvitation';
import { RegexFields } from '../../../../constants/utils/regexFields';

export const PartnerInvitationStep2 = ({user, timestamp, nonce, signature}) => {
    const history = useHistory();
    const location = useLocation();
    const formRef = useRef();
    const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfPassword, setShowConfPassword] = useState(false);
    const [passwordRequirements, setPasswordRequirements] = useState({ hasLower: false, hasUpper: false, hasDigits: false });
    const [isLoading, setIsLoading] = useState(false);
    const [passwordState, setPasswordState] = useState({
        password: '',
        confirmationPassword: ''
    });

    useEffect(() => {
        if (!R.isNil(passwordState.password)) {
			let hasUpper = !R.isNil(passwordState.password.match(RegexFields.hasUpperCase));
			let hasLower = !R.isNil(passwordState.password.match(RegexFields.hasLowerCase));
			let hasDigits = !R.isNil(passwordState.password.match(RegexFields.hasDigits));
			setPasswordRequirements({ ...passwordRequirements, hasDigits: hasDigits, hasLower: hasLower, hasUpper: hasUpper })
		}
    }, [passwordState])

    return (
        <>
            <form className="container-xl-base py-2 mb-auto" noValidate ref={formRef}>
                <h1 className="h1 text-primary font-weight-bolder mb-4">Activation de votre compte</h1>
                <label className="h5 lh-copy mb-4" htmlFor="code">Veuillez définir le mot de passe que vous devrez renseigner pour accéder à l'espace partenaires.</label>
                <div className="form-group">
                    <label className="h6 font-weight-bolder" htmlFor="passwordInput">Mot de passe</label>
                    <div className="input-group">
                        <input required minLength={8} maxLength={32} type={showNewPassword === false ? "password" : ''} className="form-control" id="passwordInput" placeholder="saisissez mot de passe" pattern={RegexFields.password} onInput={
                            (event) => {
                                event.preventDefault();
                                document.getElementById("passwordInput").setCustomValidity("");
                                document.getElementById("NotIdenticalPasswordsDiv").classList.remove('d-block');
                                setPasswordState({...passwordState, password: event.target.value});
                            }
                        } />
                        <div className="input-group-prepend">
                            <div className={"input-group-text border-left-0 rounded-right dropdown"}>
                                <i className={"eva o-30 fs-root lh-0 " + (showNewPassword === false ? 'eva-eye' : 'eva eva-eye-off')} role="button" id="showNewPassword" onClick={() => { setShowNewPassword(!showNewPassword); }}></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label className="h6 font-weight-bolder" htmlFor="confirmPasswordInput">Confirmer le mot de passe</label>
                    <div className="input-group">
                        <input required minLength={8} maxLength={32} type={showConfPassword === false ? "password" : ''} className="form-control" id="confirmPasswordInput" placeholder="saisissez mot de passe" pattern={RegexFields.password} onInput={
                            (event) => {
                                event.preventDefault();
                                document.getElementById("confirmPasswordInput").setCustomValidity("");
                                document.getElementById("NotIdenticalPasswordsDiv").classList.remove('d-block');
                                setPasswordState({...passwordState, confirmationPassword: event.target.value});
                            }
                        } />
                        <div className="input-group-prepend">
                            <div className={"input-group-text border-left-0 rounded-right dropdown"}>
                                <i className={"eva o-30 fs-root lh-0 " + (showConfPassword === false ? 'eva-eye' : 'eva eva-eye-off')} role="button" id="showConfPassword" onClick={() => { setShowConfPassword(!showConfPassword); }}></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="invalid-feedback mb-2" id="NotIdenticalPasswordsDiv"><i className="eva eva-alert-triangle-outline text-danger mr-1 fs-sm lh-root align-middle"></i>Les mots de passe ne sont pas identiques.</div>
                <div className="card alert-info text-body">
					<div className="card-body d-flex align-items-start">
						<i className="eva eva-info text-info mr-2 h3 mt-n1"></i>
						<div className="flex-grow-1">
							<h1 className="small font-weight-bolder text-info text-uppercase">Pour un mot de passe plus sûr</h1>
							<p className="small o-50 lh-copy mb-1">Pour atteindre le niveau de sécurité requis, votre mot de passe doit comporter entre 8 et 32 caractères et inclure au moins 3 des types de caractères suivants:</p>
							<div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasUpper ? '' : ' o-50')}>
								<i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasUpper ? ' text-success' : '')}></i>
								<span>une lettre majuscule (A-Z)</span>
							</div>
							<div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasLower ? '' : ' o-50')}>
								<i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasLower ? ' text-success' : '')}></i>
								<span>une lettre minuscule (a-z)</span>
							</div>
							<div role="button" className={"d-flex align-items-center small" + (passwordRequirements.hasDigits ? '' : ' o-50')}>
								<i className={"eva eva-checkmark-circle-outline mr-2" + (passwordRequirements.hasDigits ? ' text-success' : '')}></i>
								<span>un chiffre (0-9)</span>
							</div>
						</div>
					</div>
				</div>
            </form>
            <footer className="block mt-auto text-left w-100 rounded-inherit">
                <button onClick={(e) => history.push(`/auth/partner/invitation/${user.userId}/activation/step1${location.search}`)} className="btn btn-faded px-md-gutter mr-3">Retour</button>
                {
                    isLoading ?
                        <button type="button" className="btn btn-primary px-md-gutter px-4 loading-btn show"><div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Suivant</button>
                    :
                        <button className="btn btn-primary px-md-gutter px-4" onClick={(e) => {
                            if(passwordState.password !== passwordState.confirmationPassword){
                                document.getElementById("confirmPasswordInput").setCustomValidity("Les mots de passe ne sont pas identiques");
                                document.getElementById("NotIdenticalPasswordsDiv").classList.add('d-block')
                            }
                            if(formRef.current.checkValidity()){
                                setIsLoading(true);
                                UpdatePassword(user.userId, timestamp, nonce, signature, passwordState.password)
                                .then(() => {
                                    setIsLoading(false);
                                    history.push(`/auth/partner/invitation/${user.userId}/activation/step3${location.search}`)
                                })
                            }
                            formRef.current.classList.add('was-validated');
                        }}>Suivant</button>
                }
                
            </footer>
        </>
    )
}